// extracted by mini-css-extract-plugin
export default {"dialog":"Ptk8V2_x5Xg7smOH","columnsContainer":"dgKkWcIQfVk2xP4k","column":"Eu4Uvr6BQ2cLUhWH"};